var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFraudMonitoringMobileNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5968 8.50592C10.8893 7.27592 9.81681 6.20338 8.58681 6.49588C8.00931 6.63838 7.53681 7.1109 7.39431 7.6884C7.10181 8.9184 8.17431 9.99089 9.40431 9.69839C9.98931 9.55589 10.4618 9.08342 10.5968 8.50592Z",
    stroke: "#080917",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5082 12.8925C14.7907 11.6925 15.5932 9.98998 15.5932 8.09248C15.5932 4.44748 12.6382 1.5 9.0007 1.5C5.3632 1.5 2.4082 4.45498 2.4082 8.09248C2.4082 9.99748 3.2182 11.715 4.5157 12.915",
    stroke: "#080917",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00032 10.9121C5.31032 10.1771 4.88281 9.1871 4.88281 8.0921C4.88281 5.8196 6.72782 3.97461 9.00032 3.97461C11.2728 3.97461 13.1178 5.8196 13.1178 8.0921C13.1178 9.1871 12.6903 10.1696 12.0003 10.9121",
    stroke: "#080917",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72456 12.4959L6.64456 13.8385C5.78956 14.911 6.54705 16.4935 7.91955 16.4935H10.072C11.4445 16.4935 12.2096 14.9035 11.3471 13.8385L10.2671 12.4959C9.62206 11.6784 8.37706 11.6784 7.72456 12.4959Z",
    stroke: "#080917",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFraudMonitoringMobileNav);
export default __webpack_public_path__ + "static/media/fraud-monitoring-mobile-nav.5deb784d2ff6f1a7e83800134c10b3a0.svg";
export { ForwardRef as ReactComponent };